import React from 'react';

const TimerColumn = ({ startTime }) => {

  const calculateTimeDifference = (startDateTime) => {
    if (!startDateTime) {
        console.log('TimerColumn: No startDateTime provided');
        const hours = "H";
        const minutes = "M";
        const seconds = "S";
        return { hours, minutes, seconds };
    } else {
        // Parse the datetime string - handle both "YYYY-MM-DD HH:MM:SS" and ISO formats
        let startTime;
        if (typeof startDateTime === 'string' && startDateTime.includes(' ')) {
          // Format: "YYYY-MM-DD HH:MM:SS" - replace space with 'T' for ISO format
          startTime = new Date(startDateTime.replace(' ', 'T'));
          console.log('TimerColumn: Parsed datetime with space:', startDateTime, '→', startTime);
        } else {
          startTime = new Date(startDateTime);
          console.log('TimerColumn: Parsed datetime:', startDateTime, '→', startTime);
        }
        
        // Check if date is valid
        if (isNaN(startTime.getTime())) {
          console.log('TimerColumn: Invalid date!', startDateTime);
          const hours = "H";
          const minutes = "M";
          const seconds = "S";
          return { hours, minutes, seconds };
        }
        
        const endTime = new Date();

        const timeDiffInMilliseconds = endTime - startTime;
        const timeDiffInSeconds = Math.floor(timeDiffInMilliseconds / 1000);

        const hours = Math.floor(timeDiffInSeconds / 3600);
        const minutes = Math.floor((timeDiffInSeconds % 3600) / 60);
        const seconds = Math.floor(timeDiffInSeconds % 60);
        console.log('TimerColumn: Calculated time:', hours, 'h', minutes, 'm', seconds, 's');
        return { hours, minutes, seconds };
    }
};

  const { hours, minutes, seconds } = calculateTimeDifference(startTime);

  let hourStyle;

  // Convert to numbers, default to 0 if not a number (handles "H", "M", "S" strings)
  const hoursNum = typeof hours === 'number' ? hours : 0;
  const minutesNum = typeof minutes === 'number' ? minutes : 0;
  const secondsNum = typeof seconds === 'number' ? seconds : 0;
  
  const totalTimeInSeconds = hoursNum * 3600 + minutesNum * 60 + secondsNum;

  if (startTime===false || totalTimeInSeconds < 0) { // Check if total time difference is negative
    hourStyle = {border:"1px solid rgb(84, 188, 24)"};
  } else if (totalTimeInSeconds < 1800) { // Less than 30 minutes (1800 seconds)
    hourStyle = { backgroundColor: "rgb(84 188 24)", color: "#fff" }; // Green
  } else if (totalTimeInSeconds < 3600) { // Between 30 and 60 minutes
    hourStyle = { backgroundColor: "#f39b04", color: "#fff" }; // Yellow
  } else { 
    hourStyle = { backgroundColor: "red", color: "#fff", border: "none" };
  }

  return (
    <div className='justify-center' style={{ gap: "7px" }}>
      <div className='timer-ctn justify-center' style={hourStyle}>{hours}</div>
      <div className='timer-ctn justify-center' style={hourStyle}>{minutes}</div>
      <div className='timer-ctn justify-center' style={hourStyle}>{seconds}</div>
    </div>
  );
};

export default TimerColumn;
